module.exports = __webpack_public_path__ + "static/vippa-video-15sec-8aebf4c3d84b507b3d25cfa32a20814e.mp4";